import { MediaSection } from "../components/MediaSection";
import { readBootstrap } from "./about_api";
import { formatDuration } from "./formatDuration";
import styles from "./About.module.css";

const bootstrap = readBootstrap();

/** Each interval reads as its own wait plus the gap since the previous one. */
export function intervalLabel(
  daysHence: number,
  previousDaysHence?: number
): string {
  const current = formatDuration(daysHence);
  if (previousDaysHence === undefined) {
    return current;
  }
  return `${current} (${formatDuration(daysHence - previousDaysHence)})`;
}

export function AboutPage() {
  return (
    <div className={styles.page}>
      <header className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>About DoSomeReps</h1>
        <h2 className={styles.pageIntro}>
          DoSomeReps is a spaced repetition study site. You answer questions at
          widening intervals, ideally just before your brain would have forgotten
          the answer.
        </h2>
      </header>

      <MediaSection
        imageSrc={bootstrap.images.siteFormat}
        imageAlt="Site Format Image"
        title="Site Format"
        className={styles.mediaCard}
      >
        <p>
          This site uses a question/answer format of learning which has been
          shown to help activate your brain on a deeper level than by other
          methodologies like passively reading notes or watching videos. In
          order to optimally learn you need to engauge your brain! Sorry, I know
          it hurts sometimes, but no pain no gain!
        </p>
      </MediaSection>

      <MediaSection
        imageSrc={bootstrap.images.activeVsPassive}
        imageAlt="Black Board"
        imagePosition="right"
        title="Active vs. Passive Learning"
        className={styles.mediaCard}
      >
        <p>
          Spaced repetition is considered an active form of learning. Because
          you're forced to recall material you're more "actiively" using your
          brain, as opposed to jusst passively feeding yourself information andd
          hoping it sticks. Active learning hass been shown to be far more
          effective studying strategy enhances the retention of studied
          material.
        </p>
      </MediaSection>

      <MediaSection
        imageSrc={bootstrap.images.community}
        imageAlt="pcb-brain"
        title="Community"
        className={styles.mediaCard}
      >
        <p>
          There is some pre-existing material that you may be interested in
          studying on this site, however it is intended that you upload
          materials your interested in studying and share it with the community.
          Shared material gets rated by the community and you could choose to
          block users or follow others to learn from their uploaded content. You
          can also choose to keep everything you upload completely private. If
          some days you only want to study some categories instead of others,
          just unselect those categories in the take quiz page.
        </p>
      </MediaSection>

      <section className={styles.intervalsCard}>
        <div className={styles.hourglassColumn}>
          <div className={styles.hourglassFrame}>
            <img
              className={styles.hourglassImage}
              src={bootstrap.images.hourglass}
              alt="hour glass"
            />
          </div>

          <div className={styles.whyBother}>
            <h3 className={styles.whyBotherTitle}>
              Why bother with spaced repetition?
            </h3>
            <p className={styles.whyBotherText}>
              Ultimately, spaced repetition helps you permanantly retain what
              you're studying! By exposing yourself to the same material a few
              more times, you can hold onto the knowledge you teach yourself
              forever! Don't fool yourself into thinking you'll remember
              everything from one study session.
            </p>
          </div>
        </div>

        <div className={styles.intervalsColumn}>
          <h3 className={styles.intervalsTitle}>Our spaced intervals:</h3>
          <p className={styles.intervalKey}>
            <span className={styles.intervalLabel}>Total</span>{" "}
            <span className={styles.intervalGap}>(since last)</span>
          </p>

          <ol className={styles.intervalList}>
            {bootstrap.intervals.map((interval, index) => (
              <li key={interval.levelNo} className={styles.intervalItem}>
                <span className={styles.intervalLabel}>
                  {formatDuration(interval.daysHence)}
                </span>
                {index > 0 && (
                  <span className={styles.intervalGap}>
                    {" "}
                    (
                    {formatDuration(
                      interval.daysHence -
                        bootstrap.intervals[index - 1].daysHence
                    )}
                    )
                  </span>
                )}
              </li>
            ))}
          </ol>
        </div>
      </section>
    </div>
  );
}
